import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { WorkorderApiService } from 'src/app/services/api/workorder-api.service';
import { MessageService } from 'src/app/services/message.service';
import { validateFormGroup } from 'src/app/utils/form';
import { BeforeWorkorderModal2Component } from '../special-part/before-workorder-modal2/before-workorder-modal2.component';

@Component({
  selector: 'app-create-workorder-panel',
  templateUrl: './create-workorder-panel.component.html',
  styleUrls: ['./create-workorder-panel.component.scss'],
})
export class CreateWorkorderPanelComponent implements OnInit {
  formGroup: UntypedFormGroup;
  data: any = null;
  problem: any;

  constructor(
    private fb: UntypedFormBuilder,
    private api: WorkorderApiService,
    private message: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private apiBus: BusApiService,
    private dialog: MatDialog,
  ) {
    this.formGroup = this.fb.group({
      subscription: ['', [Validators.required]],
      issue: ['', [Validators.required]],
      // issue2: ['', [Validators.required]],
      detail: ['', []],
      image: [[]],
    });

    this.formGroup.valueChanges.subscribe((r) => {
      this.error = false;
    });

    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      this.data = null;
      if (id) this.findUserBusSeats(id);
    });
  }

  ngOnInit(): void {}

  error = false;
  loading = false;

  async submit() {
    if (!validateFormGroup(this.formGroup)) {
      this.error = true;
      return;
    }
    this.postProblem();
  }

  async checkProblemHelp() {
    const isHelp = this.problem.help_link;
    if (isHelp) {
      window.open(isHelp);
    }
  }

  async postProblem() {
    const value = this.formGroup.value;
    try {
      this.loading = true;
      const r = await this.api.postWordOrder(
        this.seat.id,
        this.problem.id,
        value.detail,
        value.image,
        'User',
      );
      if (r.status === 0) {
        this.afterPost(r);
      } else if (r.status === 200) {
        this.message.warn('请勿重复提交');
      } else {
        this.message.warn('提交失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  seat: any;

  onValueChange(data: any): void {
    this.seat = data;
    this.formGroup.patchValue({
      issue: '',
      // issue2: '',
    });
  }

  async findUserBusSeats(id: any) {
    try {
      this.loading = true;
      const r = await this.apiBus.getBusSeat(id);
      this.data = r.data;
      if (this.data) {
        this.formGroup.patchValue({
          subscription: this.data,
        });
        this.onValueChange(this.data);
      }
    } catch (error) {
      this.message.error('网络错误');
    } finally {
      this.loading = false;
    }
  }

  afterPost(info: any) {
    const now = new Date();
    const startDate = new Date(2026, 1, 14, 0, 0, 0);
    const stopDate = new Date(2026, 1, 24, 0, 0, 0);

    if (now < stopDate && now >= startDate) {
      this.dialog
        .open(BeforeWorkorderModal2Component, {
          width: '540px',
        })
        .afterClosed()
        .subscribe((r) => {
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/user/profile/form/workorder'], {
                queryParams: { id: info.data },
              });
            });
        });
    } else {
      this.message.open('提交成功');
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/user/profile/form/workorder'], {
          queryParams: { id: info.data },
        });
      });
    }
  }
}
